import * as React from "react";
import {Bootstrap} from "../PageBuilder/Bootstrap";
import ReactDOM = require("react-dom");

import {WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";
import { CustomFieldApp } from "./CustomFieldApp";


export class CustomFieldListBootstrap extends React.Component<TemplateListBootstrapProps, TemplateListBootstrapState> {
    static defaultProps: Partial<TemplateListBootstrapProps> = {};

    constructor(props: TemplateListBootstrapProps) {
        super(props);
        this.state = {};
        WpAjaxPost.SetGlobalVar(rednaoVarTemplateList);
    }

    public render() {
        return (
            <CustomFieldApp/>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TemplateListBootstrapProps {

}

interface TemplateListBootstrapState {

}


ReactDOM.render(<CustomFieldListBootstrap/>,document.getElementById('AppRoot'));

//#endregion "My Region"